import { siteConfig } from '@content/config'

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t">
      <div className="container-custom py-8">
        <div className="text-center text-gray-600">
          <p>&copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
